import { Divider } from 'semantic-ui-react'

const fmt = v => typeof v === 'boolean' ? (v ? 'Yes' : 'No') : (v ?? 'Empty')

export const ChangelogPanel = ({ changelog }) => (
    <div style={{ marginTop: '1.5rem', width: '100%', textAlign: 'left' }}>
        <strong>Change History</strong>
        <Divider />
        {changelog.length === 0 ? (
            <p style={{ color: '#666' }}>No changes recorded yet.</p>
        ) : (
            <div style={{ maxHeight: '20rem', overflowY: 'auto', paddingRight: '0.25rem' }}>
            {changelog.map(entry => (
                <div key={entry.id} style={{ marginBottom: '1rem', padding: '0.75rem', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '0.25rem', fontSize: '0.9em', color: '#555' }}>
                        {entry.changedBy?.name || 'Unknown Author'} &mdash; {new Date(entry.changedOn).toLocaleString()}
                    </div>
                    {entry.changes.map((change, i) => (
                        <div key={i} style={{ fontSize: '0.85em', marginLeft: '0.5rem' }}>
                            <span style={{ color: '#555' }}>{change.field}: </span>
                            <span style={{ color: 'red', textDecoration: 'line-through' }}>{fmt(change.old)}</span>
                            {' → '}
                            <span style={{ color: 'green' }}>{fmt(change.new)}</span>
                        </div>
                    ))}
                </div>
            ))}
            </div>
        )}
    </div>
)
